Object.assign(exports, {"name":"@bokeh/jupyter_bokeh","version":"4.0.5"})